import BaseApiService from "./BaseApiService";
const DEFAULT_PATH = "replaceability";

class MainApiService extends BaseApiService {
  computeReplaceability = (body: any) => {
    const endPoint = `${DEFAULT_PATH}/calculator/compute`;
    return this.makePostRequestWithoutAuth(endPoint, body);
  };
}

export default new MainApiService();
